/**
 * Uploads a blob into a signed GCS url
 */
export async function uploadBlobToSignedUrl(blob, signedUrl, contentType = null) {
    const requestOptions = {
        method: "PUT",
        headers: {
            "Content-Type": contentType ?? blob.type
        },
        body: blob
    };

    const response = await fetch(signedUrl, requestOptions);
    if (!response.ok) {
        const text = await response.text().catch(() => "");
        throw new Error(`Failed to upload blob to signed URL: ${response.status} ${response.statusText} ${text}`);
    }
}
